import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import AuthService from "./services/AuthService";

const parseJwt = (token) => {
  try {
    return JSON.parse(window.atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

const isJwtExpired = (user) => {
  if (!user?.access_token) return false;
  const decoded = parseJwt(user.access_token);
  return decoded ? decoded.exp * 1000 < Date.now() : false;
};

export default function ProtectedRoute({ children }) {
  const user = AuthService.getUser();
  const expired = isJwtExpired(user);

  useEffect(() => {
    if (expired) AuthService.logout();
  }, [expired]);

  const loggedIn = !!user?.access_token && !expired;
  return loggedIn ? children : <Navigate replace to="/signin" />;
}
